/* eslint-disable react/state-in-constructor */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Select, notification } from 'antd';
import definitionService from 'services/definition.service';

const { Option } = Select;

class SelectWithInstantFetch extends React.Component {
  state = {
    value: undefined,
    data: [],
    fetching: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const { path, labels, dataIndex, selectedValue, handleNestedFetch } = this.props;
      this.setState({ data: [], fetching: true });
      const { payload } = await definitionService.getDefinition(path);
      const data = payload.map((item) => {
        const text = labels.map((label) => item[label]);
        return {
          text: text.join(' '),
          value: dataIndex ? item[dataIndex] : JSON.stringify(item),
        };
      });
      if (selectedValue) {
        if (handleNestedFetch) {
          handleNestedFetch(selectedValue);
        }
        this.setState({ value: JSON.stringify(selectedValue) });
      }
      this.setState({ data, fetching: false });
    } catch (error) {
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  handleChange = (value) => {
    const { handleNestedFetch } = this.props;
    if (handleNestedFetch) {
      handleNestedFetch(JSON.parse(value));
    }
    this.setState({
      value,
    });
    this.triggerChange(value);
  };

  triggerChange = (value) => {
    const { onChange, multiple, dataIndex } = this.props;
    if (onChange) {
      if (multiple) {
        const newValue = value.map((val) => JSON.parse(val));
        onChange(newValue);
      } else {
        const val = dataIndex ? value : { ...JSON.parse(value) };
        onChange(val);
      }
    }
  };

  render() {
    const { value, data, fetching } = this.state;
    const { placeholder, showSearch, multiple } = this.props;
    const options = data.map((d) => <Option key={d.value}>{d.text}</Option>);

    return (
      <Select
        showSearch={showSearch}
        loading={fetching}
        value={value}
        placeholder={placeholder}
        onChange={this.handleChange}
        allowClear
        mode={multiple ? 'multiple' : 'default'}
        filterOption={(input, option) => {
          return (
            option.props.children
              .toLocaleLowerCase('tr-TR')
              .indexOf(input.toLocaleLowerCase('tr-TR')) >= 0
          );
        }}
      >
        {options}
      </Select>
    );
  }
}

export default SelectWithInstantFetch;
